// Let the prerendered content reach the compositor before creating GPU contexts.
// This is a paint milestone, not an idle timeout; warm navigation starts at once.
export function afterFirstPaint(start: () => void) {
  let cancelled = false;
  let frame = 0;
  let timer = 0;
  let observer: PerformanceObserver | undefined;
  const cleanup = () => {
    cancelled = true;
    observer?.disconnect();
    cancelAnimationFrame(frame);
    clearTimeout(timer);
  };
  const finish = () => {
    if (!cancelled) {
      cleanup();
      start();
    }
  };
  if (
    performance
      .getEntriesByType("paint")
      .some((entry) => entry.name === "first-contentful-paint")
  ) {
    finish();
  } else if (
    typeof PerformanceObserver !== "undefined" &&
    PerformanceObserver.supportedEntryTypes?.includes("paint")
  ) {
    observer = new PerformanceObserver((entries) => {
      if (
        entries
          .getEntries()
          .some((entry) => entry.name === "first-contentful-paint")
      ) {
        finish();
      }
    });
    observer.observe({ buffered: true, type: "paint" });
  } else {
    // Browsers without Paint Timing still get a frame and its following task.
    frame = requestAnimationFrame(() => {
      frame = 0;
      timer = window.setTimeout(finish, 0);
    });
  }
  return cleanup;
}
